<template>
  <div class="main-container">
    <div class="home-page">
      <div class="home-page__left">
        <main-menu></main-menu>
      </div>
    </div>
  </div>
</template>

<script>
  import ClearCacheBtn from '../ClearCacheBtn/ClearCacheBtn.vue'
  import MainMenu from '../MainMenu/MainMenu.vue'
  export default {
    name: 'HomePage',
    components: {MainMenu, ClearCacheBtn}
  }
</script>

<style scoped src="./homePage.scss" lang="scss"></style>
